<script>
export default {
  name: 'IconFacebook',
}
</script>

<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 14 14"
  >
    <path
      d="M7 0c3.85 0 7 3.168 7 7.04 0 3.48-2.528 6.373-5.833 6.96l-.041-.031a5.42 5.42 0 0 0 .04-.008V8.994h1.556l.311-1.955H8.167V5.67c0-.547.194-.977 1.05-.977h.894v-1.8c-.505-.077-1.05-.156-1.555-.156-1.595 0-2.723.978-2.723 2.738v1.564h-1.75v1.955h1.75v4.967l.041.006-.04.033C2.527 13.413 0 10.52 0 7.04 0 3.167 3.15 0 7 0Z"
      fill="#4267B2"
      fill-rule="nonzero"
    />
  </svg>
</template>
